import React from "react";
import { Props } from "../../types/global";
import { TopupService } from "../services/topup-service";
import { ReceiptTrx } from "../types";
import t from "../i18n";
import NotificationSubscriptionComp from "../common/NotificationSubscription";
import { SkuCategory } from "../types-enums";

declare type ReceiptState = {
    receiptTrx?: ReceiptTrx;
    fetchTimer?: NodeJS.Timer;
    secondsTimer?: NodeJS.Timer;
    secondsLeft: number;
}
export default class TrxTimeout extends React.Component<Props, ReceiptState> {
    readonly state: ReceiptState = { secondsLeft: 60 };
    async componentDidMount() {
        const { sessionId } = this.props.location.query;
        const response = await TopupService.fetchReceipt(undefined, sessionId);
        if (response && response.responseCode === 0) {
            const receiptTrx = response.payLoad!;
            this.props.history.replace(`/receipt?transactionId=${receiptTrx.receipt.transactionId}`);
            return;
        }
        const fetchTimer = setInterval(() => {
            this.fetchTrx();
        }, 10000);
        const secondsTimer = setInterval(() => {
            const secondsLeft = this.state.secondsLeft;
            this.setState({ secondsLeft: Math.max(0, secondsLeft - 1) })
        }, 1000);
        this.setState({ fetchTimer: fetchTimer, secondsTimer: secondsTimer });
    }
    componentWillUnmount() {
        if (this.state.fetchTimer) clearInterval(this.state.fetchTimer);
        if (this.state.secondsTimer) clearInterval(this.state.secondsTimer);
    }
    fetchTrx = async () => {
        const { sessionId } = this.props.location.query;
        const response = await TopupService.fetchReceipt(undefined, sessionId);
        if (!response) return;
        if (response.responseCode === 0) {
            const receiptTrx = response.payLoad!;
            this.props.history.replace(`/receipt?transactionId=${receiptTrx.receipt.transactionId}`);
        }
    }
    render() {
        const topup_title = "topup-timeout";
        const purchase_title = "purchase-timeout";
        const skuCategory = this.state.receiptTrx?.receipt.skuCategory;
        if (!skuCategory) return null;
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{ skuCategory == SkuCategory.GiftCard ? t.receipt(purchase_title) : t.receipt(topup_title)}</h2>
            </div>
            <div>
                <div>{t.receipt("topup-timeout-msg-1")}</div>
                <br />
                <div>{t.receipt("topup-timeout-msg-2")}</div>
                <br />
                <div>{t.receipt("topup-timeout-msg-3")}</div>
                <br />
                <div dangerouslySetInnerHTML={{
                    __html: t.receipt("topup-timeout-msg-4", {secondsLeft: this.state.secondsLeft})
                }} />
            </div>
            <div>
                <NotificationSubscriptionComp></NotificationSubscriptionComp>
            </div>
        </div>
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}